var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.257812,
    y: 0.664062,
    width: 25.7503,
    height: 25.7503,
    rx: 12.8751,
    fill: "#F9CF66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4745 11.1989V9.4432L17.2302 7.6875L17.8154 8.85797L18.9859 9.4432L17.2302 11.1989H15.4745ZM15.4745 11.1989L13.1336 13.5398M18.9859 13.5398C18.9859 16.772 16.3657 19.3922 13.1336 19.3922C9.90143 19.3922 7.28125 16.772 7.28125 13.5398C7.28125 10.3077 9.90143 7.6875 13.1336 7.6875M16.0597 13.5398C16.0597 15.1559 14.7497 16.466 13.1336 16.466C11.5175 16.466 10.2074 15.1559 10.2074 13.5398C10.2074 11.9238 11.5175 10.6137 13.1336 10.6137",
    stroke: "#FFFBE5",
    strokeWidth: 1.40456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.326bdd076723609280b7189dd5796917.svg";
export { ForwardRef as ReactComponent };